import React, {Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';
import Register from '../auth/Register';
import Login from '../auth/Login';
import Alert from '../layout/Alert';
import Dashboard from '../dashboard/Dashboard';
import ProfileForm from '../profile-forms/ProfileForm';
import AddExperience from '../profile-forms/AddExperience';
import AddEducation from '../profile-forms/AddEducation';
import Profiles from '../profiles/Profiles';
import Profile from '../profile/Profile';
import Posts from '../posts/Posts';
import Post from '../post/Post';
import NotFound from '../layout/NotFound';
import PrivateRoute from './PrivateRoute';
import Forgot from "../auth/Forgot";
import Chat from "../chat/chat";
import PropertyListing from "../addProperty/propertListing";
import PropertiesList from "../PropetiesList/properties-list";
import AddProperty from "../addProperty/addProperty";
import UserProfile from "../userProfile/userProfile";
import AdminProfile from "../userProfile/adminProfile";
import Invite from "../Invite/invite";
import changePassword from "../auth/change-password";
import AgentListing from "../profile/agentListing";
import ConnectionListing from "../profile/connectionListing";
import PropertyDetails from "../common/Properties/propertyDetails";
import PrivatePropertyList from "../common/Properties/Private/privatePropertyList";
import Users from "../userProfile/users";
import PageTitle from "../page-title/pagetitle";
import AddUpdatePage from "../page-title/AddUpdatePage";
import AddUpdateUsers from "../userProfile/AddUpdateUsers";
import Permission from "../Permission/permission";
import ProtectedRoute from "./ProtectedRoute";
import NewPropertyDetails from "../PropetiesList/new-property-details";
import viewProfile from "../userProfile/viewProfile";
import ResetPassword from "../auth/ResetPassword";
import Admin from "../admin/admin";
import Groups from "../admin/groups";
import ProtectedRouteAdmin from "./ProtectedRouteAdmin";
import adminLogin from "../auth/adminLogin";
import PermissionInfo from "../Permission/permisionInfo"


const Routes = () => {
    return (
        <Fragment>
            <Alert/>
            <Switch>
                <ProtectedRouteAdmin exact path="/users" component={Admin}/>
                <ProtectedRouteAdmin exact path="/groups" component={Groups}/>
                <ProtectedRouteAdmin exact path="/permission-info" component={PermissionInfo}/>
                <ProtectedRouteAdmin exact path="/add-user" component={AddUpdateUsers}/>
                <ProtectedRouteAdmin exact path="/view-user/:id" component={viewProfile}/>
                <ProtectedRouteAdmin exact path="/admin-profile" component={AdminProfile}/>
                <ProtectedRouteAdmin exact path="/permission" component={Permission}/>
                <ProtectedRouteAdmin exact path="/update-user/:id" component={AddUpdateUsers}/>
                <Route exact path="/register/:ref_id" component={Register}/>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/forgot-password" component={Forgot}/>
                <PrivateRoute exact path="/change-password" component={changePassword}/>
                <Route exact path="/reset-password/:userId" component={ResetPassword}/>
                <Route exact path="/admin" component={adminLogin}/>
                {/*<ProtectedRoute exact path="/users" component={Users}/>*/}
                <ProtectedRoute exact path="/page-title" component={PageTitle}/>
                <Route exact path="/profiles" component={Profiles}/>
                <Route exact path="/profile/:id" component={Profile}/>
                {/*<Route exact path="/property-details/:property_id" component={PropertyDetails} />*/}
                <Route exact path="/new-property-details/:property_id" component={NewPropertyDetails}/>
                <PrivateRoute exact path="/private-chat" component={Chat}/>
                <PrivateRoute exact path="/home" component={Chat}/>
                <PrivateRoute exact path="/agent-listing" component={AgentListing}/>
                <PrivateRoute exact path="/connections" component={ConnectionListing}/>
                <ProtectedRoute exact path="/add-page" component={AddUpdatePage}/>
                <PrivateRoute exact path="/add-property" component={AddProperty}/>
                <PrivateRoute exact path="/update-property/:id" component={AddProperty}/>
                <PrivateRoute exact path="/invite" component={Invite}/>
                <Route exact path="/dashboard" component={Dashboard}/>
                <PrivateRoute exact path="/user-profile" component={UserProfile}/>
                <PrivateRoute exact path="/create-profile" component={ProfileForm}/>
                <PrivateRoute exact path="/edit-profile" component={ProfileForm}/>
                <PrivateRoute exact path="/add-experience" component={AddExperience}/>
                <PrivateRoute exact path="/add-education" component={AddEducation}/>
                <PrivateRoute exact path="/posts" component={Posts}/>
                <PrivateRoute exact path="/posts/:id" component={Post}/>
                {/*<PrivateRoute exact path="/properties" component={PropertiesList} />*/}
                <PrivateRoute exact path="/properties" component={PropertiesList}/>
                <PrivateRoute exact path="/private-properties" component={PrivatePropertyList}/>

                <Route component={NotFound}/>
            </Switch>
        </Fragment>
    );
};

export default Routes;
